<template>
  <div class="maintenance-container">
    <div class="maintenance-content">
      <div class="logo-container">
        <img src="@/assets/GNet.png" alt="Gaia Net Logo" />
      </div>
      <h1 class="title is-2">Under Maintenance</h1>
      <p class="subtitle is-4">
        Gaia Net is currently down for temporary maintenance
      </p>
      <p class="has-text-grey">
        We apologize for the inconvenience. We'll be back online shortly.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
};
</script>

<style scoped>
.maintenance-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.maintenance-content {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  max-width: 600px;
}

.logo-container {
  margin-bottom: 2rem;
}

.logo {
  max-width: 350px;
  height: 300px;
}

.icon-container {
  margin-bottom: 2rem;
  color: #667eea;
}

.title {
  margin-bottom: 1rem;
}

.subtitle {
  margin-bottom: 1.5rem;
  color: #363636;
}
</style>
